import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './DonatePage.module.css'; // Reuse some styles
import { trackEvent } from '../utils/analytics';
import { useMediaQuery } from '../hooks/useMediaQuery';
// Logo is used directly in src attribute: <img src="/logo.png" ... />

function CancelPage() {
  // Track donation cancellation with Google Analytics
  useEffect(() => {
    trackEvent(
      'Donation',
      'Donation Cancelled',
      'Cancel Page',
      0
    );
  }, []);

  // Use media query hooks for responsive design
  const isMobile = useMediaQuery('(max-width: 480px)');

  const linkStyle = {
    display: 'block',
    width: isMobile ? '100%' : '80%',
    maxWidth: '300px',
    margin: '10px auto',
    padding: '12px 20px',
    textAlign: 'center',
    backgroundColor: '#007bff',
    color: 'white',
    borderRadius: '4px',
    textDecoration: 'none',
    fontWeight: '500',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.3s ease'
  };

  const secondaryLinkStyle = {
    ...linkStyle,
    backgroundColor: '#3498db', // Consistent blue for secondary actions
    marginTop: '15px'
  };

  const linkHoverStyle = { // Define hover style for JS-styled links
    opacity: 0.85,
    transform: 'translateY(-1px)'
  };

  return (
    <div className={styles.donatePageContainer}>
      <div className={styles.logoContainer}>
        <img src="/logo.png" alt="Shul Logo" className={styles.logo} />
      </div>
      <h1>Donation Cancelled</h1>
      <div className={styles.errorMessage}>
        Your donation process was cancelled or encountered an issue.
      </div>
      <p style={{
        textAlign: 'center',
        marginTop: '20px',
        fontSize: isMobile ? '0.9rem' : '1rem',
        padding: '0 10px',
        lineHeight: '1.6',
        color: '#555'
      }}>
        If you experienced a problem, please try again or contact us for assistance.
        No payment has been processed.
      </p>
      <div style={{ marginTop: '30px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Link 
          to="/donate" 
          style={linkStyle}
          onMouseOver={(e) => e.currentTarget.style.opacity = linkHoverStyle.opacity }
          onMouseOut={(e) => e.currentTarget.style.opacity = 1 }
        >
          Try Again
        </Link>
        <Link 
          to="/" 
          style={secondaryLinkStyle}
          onMouseOver={(e) => e.currentTarget.style.opacity = linkHoverStyle.opacity }
          onMouseOut={(e) => e.currentTarget.style.opacity = 1 }
        >
          Return to Homepage
        </Link>
      </div>
    </div>
  );
}

export default CancelPage;
